<ion-button shape="round" class="btnTop" (click)="scrollTop()">
  <ion-icon slot="icon-only" name="caret-up-outline" class="text-2xl mb-1"></ion-icon>
</ion-button>